export const INITIALIZE_NOTIFICATION_STATE = "INITIALIZE_NOTIFICATION_STATE";

export const TOGGLE_FETCHING_NOTIFICATIONS = "TOGGLE_FETCHING_NOTIFICATIONS";

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";

export const MARK_AS_READ = "MARK_AS_READ";

export const MARK_ALL_AS_READ = "MARK_ALL_AS_READ";
